/**
 * Client-side checks for document rejection popups (reason + employee message).
 */

export function hasRejectionReasonSelection(
  selectedRejectReason: { id?: string | number } | null | undefined,
  optionOrId?: unknown
): boolean {
  if (selectedRejectReason?.id != null && String(selectedRejectReason.id).trim() !== '') {
    return true;
  }
  if (optionOrId === undefined || optionOrId === null) {
    return false;
  }
  if (typeof optionOrId === 'string' || typeof optionOrId === 'number') {
    return String(optionOrId).trim() !== '';
  }
  if (typeof optionOrId === 'object' && optionOrId !== null && 'id' in optionOrId) {
    const id = (optionOrId as { id?: unknown }).id;
    return id != null && String(id).trim() !== '';
  }
  return false;
}

export function hasNonBlankEmployeeRejectionMessage(reason: string | null | undefined): boolean {
  return String(reason ?? '').trim().length > 0;
}
